var React = require('react');

function LineArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Line-Arrow-Left-1--Streamline-Sharp"},React.createElement("g",{"id":"line-arrow-left-1--arrow-keyboard-left"},[React.createElement("path",{"id":"Vector 2248","d":"M0.700195 8L14.3877 8","stroke":"#141414","strokeWidth":"1.4","key":0}),React.createElement("path",{"id":"Vector 2249","d":"M9.52103 3.13337L14.3877 8.00003L9.52103 12.8667","stroke":"#141414","strokeWidth":"1.4","key":1})])));
}

LineArrowRight.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = LineArrowRight;

LineArrowRight.default = LineArrowRight;
